import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';

const selectors = {
	el: '.js-user-menu',
	name: ',js-user-name',
	text: '.js-user-text',
	btn: '.js-user-btn'
};

const states = {
	login: 'user-menu_login'
};

const btnText = {
	login: 'Войти',
	logout: 'Выйти'
};

const toggleMenu = (state, menu, text) => {
	if (state === 'logout') {
		menu.classList.add(states.login);
		menu.dataset.state = 'login';
		text.textContent = btnText.logout;
	}else {
		menu.classList.remove(states.login);
		menu.dataset.state = 'logout';
		text.textContent = btnText.login;
	}
};

const onClick = e => {
	const target = e.currentTarget;
	const text = target.querySelector(selectors.text);
	const menu = target.closest(selectors.el);
	const state = menu.dataset.state;
	toggleMenu(state, menu, text);
};

const setHandlers = () => {
	bindEvent(selectors.btn, 'click', onClick);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/user-menu/index.js